import { type Locale, resolveDeviceLocale } from '@/i18n/config';

/**
 * The locale every reader resolves against — `translateFile` in a util, `t`
 * inside a component, `Intl` formatting, the `Accept-Language` header.
 *
 * It is a store rather than React state on purpose. The locale is read from
 * outside React (API clients, Joi schemas, label maps), so keeping a second
 * copy in a context and syncing it with an effect made the two disagree: the
 * context updated on the render, the module updated after the paint, and
 * nothing re-rendered afterwards to reconcile them.
 *
 * `useTranslate` subscribes through `useSyncExternalStore`, so a component
 * re-renders on a language change without depending on where it sits in the
 * tree, and reads the same value a util would read in the same render.
 */
const activeLocale: Locale = resolveDeviceLocale();

const listeners = new Set<() => void>();

export function getActiveLocale(): Locale {
  return activeLocale;
}

export function subscribeToActiveLocale(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}
